import moment from "moment";

export const DateFormate = (data, formate) => {
  let formatedData = moment(new Date(data)).format(formate);
  return formatedData;
};
